import { BlockType } from '../../types/index.js';
import { SelectBlock as Component } from './Block.js';
export const RegisteredSelectBlock = (_intl) => ({
    recommendedName: 'Select',
    Component,
    config: { type: BlockType.BuildingBlock },
});
//# sourceMappingURL=registered.js.map